const PAYLOAD = "payload";

export const getPayload = () => {
  return window.localStorage.getItem(PAYLOAD);
};

export const savePayload = savePayload => {
  window.localStorage.setItem(PAYLOAD, savePayload);
};

export const destroyPayload = () => {
  window.localStorage.removeItem(PAYLOAD);
};

export default {
  getPayload,
  savePayload,
  destroyPayload
};
